// Arabic
export const arAR = {
  props: {
    MuiBreadcrumbs: {
      expandText: "Show path",
    },
    MuiTablePagination: {
      backIconButtonText: "الصفحة السابقة",
      labelRowsPerPage: "سطور في الصفحة:",
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} من ${count !== -1 ? count : `أكثر من ${to}`}`,
      nextIconButtonText: "الصفحة التالية",
    },
    MuiRating: {
      getLabelText: (value) => `${value} Star${value !== 1 ? "s" : ""}`,
      emptyLabelText: "فارغ",
    },
    MuiAutocomplete: {
      clearText: "مسح",
      closeText: "اغلاق",
      loadingText: "يتم التحميل...",
      noOptionsText: "لا يوجد خيارات",
      openText: "افتح",
    },
    MuiAlert: {
      closeText: "اغلاق",
    },
    MuiPagination: {
      "aria-label": "Pagination navigation",
      getItemAriaLabel: (type, page, selected) => {
        if (type === "page") {
          return `${selected ? "" : "اذهب الى "}الصفحة ${page}`;
        }
        if (type === "first") {
          return "اذهب الى الصفحة الاولى";
        }
        if (type === "last") {
          return "اذهب الى اخر صفحة";
        }
        if (type === "next") {
          return "اذهب الى الصفحة التالية";
        }
        if (type === "previous") {
          return "اذهب الى الصفحة السابقة";
        }
        return undefined;
      },
    },
  },
};
